import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Task from "@/services/task";
import ReactiveComponent from "@/components/ReactiveComponent";
import TemplateContent from "@/components/template/TemplateContent.vue";
import DashboardUserWidget from "@/components/DashboardUserWidget.vue";
import DashboardBoardsWidget from "@/components/DashboardBoardsWidget.vue";
let Dashboard = class Dashboard extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.usersCount = 0;
        this.femaleUsersCount = 0;
        this.maleUsersCount = 0;
        this.coachUsersCount = 0;
        this.boardStats = new Array();
        this.statsTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: 'stats',
            options: {
                query: require('@/apollo/queries/dashboardStats.graphql')
            },
            onTask: task => {
                this.statsTask = task;
                if (task.isSuccessful) {
                    this.usersCount = task.data.users.aggregate.count;
                    this.femaleUsersCount = task.data.female_users.aggregate.count;
                    this.maleUsersCount = task.data.male_users.aggregate.count;
                    this.coachUsersCount = task.data.coach_users.aggregate.count;
                    this.boardStats = task.data.board_aggregate.nodes;
                }
            }
        });
    }
};
Dashboard = __decorate([
    Component({
        components: { TemplateContent, DashboardUserWidget, DashboardBoardsWidget },
    })
], Dashboard);
export default Dashboard;
